module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-simple-columns2 row"
  }, [_c('div', {
    staticClass: "columns n1 small-6"
  }, [_vm._t("n1")], 2), _c('div', {
    staticClass: "columns n2 small-6"
  }, [_vm._t("n2")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61071b98!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/simpleColums2.vue
// module id = 2522
// module chunks = 1